import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Frame, TopBar, Loading } from "@shopify/polaris";
import { ExitIcon } from "@shopify/polaris-icons";
import { useTranslation } from "react-i18next";
import {
  checkSession,
  logout,
  toogleUserMenu,
} from "features/auth/authSlice";
import MyOnboarding from "containers/my-onboarding/my-onboarding";
import Modalx from "components/modalx/modalx";

import { APP_CONFIG } from "config/app-config";

function OnboardingLayout() {
  const dispatch: any = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { session, isLoading, isError, userMenuActive } = useSelector(
    (state: any) => state.authReducer
  );

  useEffect(() => {
    if (isError) {
      (window as any).asist = { redirect: window.location.pathname };
      navigate("/auth/login");
    } else if (!session && !isLoading) {
      dispatch(checkSession());
    }
  }, [navigate, dispatch, session, isLoading, isError]);

  // If session loaded and user does NOT have pending onboarding, redirect to main app
  useEffect(() => {
    if (session && session.hasPendingOnboarding === false) {
      navigate("/app", { replace: true });
    }
  }, [session, navigate]);

  if (!session) {
    return (
      <Frame>
        <Loading />
      </Frame>
    );
  }

  const handleLogOut = async () => {
    await dispatch(logout());
  };

  const handleToggleUserMenu = () => {
    dispatch(toogleUserMenu());
  };

  const userMenuActions: any = [
    {
      items: [
        { content: t("log_out"), icon: ExitIcon, onAction: handleLogOut },
      ],
    },
  ];

  const userMenuMarkup = (
    <TopBar.UserMenu
      actions={userMenuActions}
      name={session.name || session.email}
      initials={(session.name || session.email || "U").charAt(0).toUpperCase()}
      open={userMenuActive}
      onToggle={handleToggleUserMenu}
    />
  );

  const Logo = (
    <div
      style={{
        color: "#fff",
        height: "100%",
        width: "100%",
        cursor: "default",
      }}
    >
      <h1 className="font-semibold text-white">
        {APP_CONFIG.isUhbGroup ? "UHB Group" : APP_CONFIG.siteName}
      </h1>
    </div>
  );

  const topBarMarkup = (
    <div className="company_select_box">
      <TopBar
        userMenu={userMenuMarkup}
        logoSuffix={Logo}
      />
    </div>
  );

  return (
    <div className="main_content">
      <Frame topBar={topBarMarkup}>
        <div style={{ maxWidth: 900, margin: "0 auto", padding: "20px 16px" }}>
          <MyOnboarding />
        </div>
        <Modalx />
      </Frame>
    </div>
  );
}

export default OnboardingLayout;
